import { render, staticRenderFns } from "./SyntheseList.vue?vue&type=template&id=eeed8b10&"
import script from "./SyntheseList.vue?vue&type=script&lang=js&"
export * from "./SyntheseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports